import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { hexToRgba } from 'builder/styles/colors'

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
  flex-direction: column;
`

export const Animation = styled.div`
  will-change: width, height;
  background: ${hexToRgba(Colors.Blue50, 0.1)};
  border-radius: 50%;
  position: absolute;
  z-index: 1;
  height: 124px;
  width: 124px;
  transition: width 300ms ease-in-out, height 300ms ease-in-out;
`

export const Children = styled.div`
  z-index: 2;
`
